export const GET_EXCHANGE_RATE_ACTIONS = {
    GET_EXCHANGE_RATE_STARTED: 'GET_EXCHANGE_RATE_ACTION_STARTED',
    GET_EXCHANGE_RATE_OK: 'GET_EXCHANGE_RATE_ACTION_OK',
    GET_EXCHANGE_RATE_ERROR: 'GET_EXCHANGE_RATE_ACTION_ERROR',
    GET_EXCHANGE_RATE_INVALID_RESPONSE: 'GET_EXCHANGE_RATE_ACTION_INVALID_RESPONSE',
    GET_EXCHANGE_RATE_INVALID_JSON: 'GET_EXCHANGE_RATE_ACTION_INVALID_JSON',
}
